<template lang="html">
  <div id="profile-settings" class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 no-pad-both">

    <div class="white-box profile-bike-speed">
      <div style="padding: 20px 0px;">
        <span class="input-headline">Cykelhastighed</span>
        <p>Hvor hurtig er du på cyklen? Sæt markøren, så den passer til din forventede gennemsnitshastighed inklusiv ventetid i krydsene. Så beregnes den forventede tid på dine cykelruter herudfra.</p>
        <div id="speed-sticks-text"><div id="speed-left-text" class="speed-text">Langsom (10km/t)</div><div id="speed-middle-text" class="speed-text">Gennemsnitlig (16km/t)</div><div id="speed-right-text" class="speed-text">Hurtig (30km/t)</div></div>
        <div id="speed-sticks"><div id="speed-left"></div><div id="speed-middle"></div><div id="speed-right"></div></div>
        <div id="speed-slider-container" tabindex="0">
          <input type="range" min="1" max="9" value="5" class="slider" id="speed-slider" aria-label="Din gennemsnitshastighed i km i timen">
        </div>
      </div>
    </div>

    <div class="white-box profile-setting-box" role="button" @click="deleteFavoriteData" tabindex="0">
      <span class="input-headline">Slet favoritter</span>
      <span class="float-right"><span class="material-icons grey-text" aria-hidden="true">delete</span></span>
    </div>

    <div class="white-box profile-setting-box" role="button" @click="deleteUserData" tabindex="0">
      <span class="input-headline">Slet alle brugerdata</span>
      <span class="float-right"><span class="material-icons grey-text" aria-hidden="true">delete</span></span>
    </div>

    <div class="white-box profile-setting-box" role="button" @click="requestNewPassword" v-if="loginType == 'user'" tabindex="0">
      <span class="input-headline">Skift kodeord</span>
      <span class="float-right"><span class="material-icons grey-text" aria-hidden="true">lock</span></span>
    </div>

    <div class="white-box profile-setting-box" role="button" @click="deleteProfilePrompt" tabindex="0">
      <span class="input-headline">Slet profil</span>
      <span class="float-right"><span class="material-icons grey-text" aria-hidden="true">delete_forever</span></span>
    </div>

  </div>
</template>

<script>
import { EventBus } from '@/main.js'
import Profile from '@/assets/profile/Profile.js'
import axios from 'axios'

export default {
  data() {
    return {
      settingsData: [],
      loginType: false,
    }
  },
  created() {
    this.loginType = Profile.loginType;
    Profile.getUserData().then((data) => {
      this.settingsData = data.userData;
      this.loadSettings();
    });
  },
  methods: {
  	loadSettings() {
  		var speed = (Profile.userData.userData.cycleSpeed && Profile.userData.userData.cycleSpeed != undefined) ? Profile.userData.userData.cycleSpeed : 5;
  		var slider = document.getElementById('speed-slider');
  		slider.value = speed;
  		slider.oninput = function() {
  			Profile.setCycleSpeed(this.value);
  		}
  	},

    requestNewPassword() {
      Profile.requestNewPassword().then(() => {
        var obj = {message: 'Der er blevet sendt en besked til din e-mail-adresse med instruktioner om ændring af dit password.', headline: 'Nyt kodeord', btnText: 'Ok'};
        EventBus.$emit('openMessageBox', obj);
      });
  	},

  	deleteProfilePrompt() {
      if(Profile.loginType == 'facebook') {
        var deleteMessage = 'Er du sikker på, at du vil slette din profil? Din profil kan ikke gendannes. Din Facebook-profil påvirkes ikke af denne handling.';
      }
      else {
        var deleteMessage = 'Er du sikker på, at du vil slette din profil? Din profil kan ikke gendannes.';
      }

      var obj = {message: deleteMessage, headline: 'Slet bruger', btnText: 'Ok', cancelBtnText: 'Fortryd', callbackType: 'function', callback: this.deleteProfile};
      EventBus.$emit('openMessageBox', obj);
  	},

  	deleteProfile() {
  		if(Profile.loginType == 'facebook') {
        Profile.deleteUser(true).then(() => {
          var obj = {message: 'Din profil er nu slettet.', headline: 'Profil slettet', btnText: 'Ok', callbackType: 'function', callback: Profile.logout};
          EventBus.$emit('openMessageBox', obj);
        });
  		}
  		else if(Profile.loginType == 'user') {
        Profile.deleteUser().then(() => {
          let msg = 'Du vil modtage en email, hvor du skal bekræfte, at du vil slette din profil.';
          var obj = {message: msg, headline: 'Email sendt', btnText: 'Ok', callbackType: 'function', callback: Profile.logout};
          EventBus.$emit('openMessageBox', obj);
        });
  		}
      this.$HelperFunctions.trackSession('user', 'user-deleted');
  	},

  	deleteFavoriteData() {
  		let settings = {message: 'Er du sikker på, at du vil slette favoritter?', btnText: 'Bekræft', cancelBtnText: 'Anuller', callbackType: 'function', callback: Profile.deleteFavorites};
  		EventBus.$emit('openMessageBox', settings);
  	},

  	deleteUserData() {
  		let settings = {message: 'Er du sikker på, at du vil slette din data?', btnText: 'Bekræft', cancelBtnText: 'Anuller', callbackType: 'function', callback: Profile.deleteUserData};
  		EventBus.$emit('openMessageBox', settings);
  	},
  }
}
</script>

<style lang="css">
  #profile-settings {
    margin-bottom: 10px;
  }

  .profile-bike-speed, .profile-setting-box {
    margin-top: 10px;
  	font-size: 16px;
  	padding: 0px 20px;
  }

  .profile-setting-box {
    height: 50px;
  	line-height: 50px;
  	vertical-align: middle;
    cursor: pointer;
  }

  .profile-setting-box input {
  	height: 30px;
  }

  .profile-setting-box .material-icons {
  	position: relative;
  	top: 10px;
  }

  .input-headline {
    font-weight: 600;
  }

  /*-------Speed Slider----------*/
  #speed-slider-container {
  	width: 100%;
  }

  #speed-slider {
    -webkit-appearance: none;
    width: 100%;
    height: 15px;
    border-radius: 5px;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    -webkit-transition: .2s;
    transition: opacity .2s;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: rgb(000, 112, 141);
    cursor: pointer;
  }

  .slider::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: rgb(000, 112, 141);
    cursor: pointer;
  }

  #speed-sticks, #speed-sticks-text {
    position: relative;
    width: 100%;
  }

  .speed-text {
  	display: inline-block;
  	width: 33%;
  	height: 20px;
  	font-size: 12px;
  }

  #speed-left-text {
  	text-align: left;
  }

  #speed-middle-text {
  	text-align: center;
  }

  #speed-right-text {
  	text-align: right;
  }

  #speed-sticks {
  	margin-bottom: 5px;
  	height: 10px;
    text-align: center;
  }

  #speed-left, #speed-middle, #speed-right {
  	position: absolute;
  	display: inline-block;
    width: 1px;
    border-right: 1px solid #d3d3d3;
    height: 10px;
  }

  #speed-left {
  	left: 12px;
  }

  #speed-middle {
  	left: 50%;
  }

  #speed-right {
  	right: 12px;
  }
</style>
